// @flow
import React from 'react';

import Chart from '../../chart/Chart';
import { ActivityMetrics } from '../types';

type Props = {
  metrics: ActivityMetrics,
};

const ActivityChart = ({ metrics }: Props) => {
  const {
    openJobOffers,
    openJobRequestsWithNoOffers,
    openJobRequests,
    startedJobs,
    pendingTutors,
  } = metrics;

  const data = {
    labels: [
      'Open Offers',
      'Open Requests with No Offers',
      'Open Requests',
      'Started Jobs',
      'Pending Tutors',
    ],
    datasets: [
      {
        label: 'Activity',
        borderWidth: 1,
        data: [
          openJobOffers,
          openJobRequestsWithNoOffers,
          openJobRequests,
          startedJobs,
          pendingTutors,
        ],
      },
    ],
  };

  return <Chart width={400} height={400} data={data} />;
};

export default ActivityChart;



// WEBPACK FOOTER //
// ./src/components/home/activity/ActivityChart.js